module.exports = __webpack_public_path__ + "img/financial.c68383fc.png";